import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { GroupGeometricPersistOp, RepositionCommandPayload } from '@/api/types/group-commands'
import type { StowedElement } from '@/api/types/stowed-element'

/**
 * The `enqueueReposition` payload for a group transform: the group row's committed geometry plus
 * the persist batch already built for its subtree. `meta` is passed through as each caller builds
 * it — the single-shape commit always sends an object, the batch paths omit it without a txn id.
 */
export function buildGroupRepositionPayload(
  group: ShapeData,
  geometricOperation: GroupGeometricPersistOp,
  stowedBatch: StowedElement[],
  meta: RepositionCommandPayload['meta']
): Omit<RepositionCommandPayload, 'spreadId' | 'layer'> {
  return {
    groupId: group.id,
    x: group.x,
    y: group.y,
    width: group.width,
    height: group.height,
    rotation: group.rotation ?? 0,
    meta,
    geometricOperation,
    stowedBatch,
  }
}
